import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref } from 'vue'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isVisible = ref(false)
const text = ref('')
const color = ref('')

onMounted(async () => {
  bus.$on(EventNames.SHOW_SNACKBAR, (data: { color: string; text: string; time: number }) => {
    showSnackbar(data.color, data.text, data.time)
  })
})

const showSnackbar = (newColor: string, newText: string, newTime: number): void => {
  color.value = newColor
  text.value = newText
  isVisible.value = true
  setTimeout(() => (isVisible.value = false), newTime || 2000)
}

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["pl-4 rounded-lg align-center snackbar d-flex", `bg-${color.value}`])
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(text.value)), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})